import { UserTypeEnum } from '../../enums/user-type.enum';
import { LocalStorageService, SessionStorageService  } from 'ngx-webstorage';
//import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { TokenService } from './token.service';
import { LogoutType } from '../../enums/logout-types.enum';
import { UserLoginModel } from '../../models/outros/user-login.model';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Variables } from '../../utils/variables';
import { GuideStorageService } from '../../../shared/guide/guide-storage.service';


@Injectable({
  providedIn: 'root'
})
export class UserControllerService {

  // private userSubject = new BehaviorSubject<UserLoginModel>(null);
  private userSubject = new BehaviorSubject<UserLoginModel>({});
  // private user: UserLoginModel;
  private user: UserLoginModel = new UserLoginModel;
  private userType = UserTypeEnum;

  constructor(
    private localStorage: LocalStorageService,
    private sessionStorage: SessionStorageService,
  
    private tokenService: TokenService,
    //private toastrService: ToastrService,
    private router: Router
  ) { }

  setUser(user: UserLoginModel) {
    this.user = user;
    this.localStorage.store(Variables.USER_AUTH, user);
    this.userSubject.next(user);
  }

  getUserInfo() {
    return localStorage.getItem(Variables.USER_DATA);
  }

  getUserLogged(): UserLoginModel {
    return this.user;
  }

  isAdmin(): boolean {
    return (this.user.type == this.userType.ADMINISTRADOR)
  }

  isAdminDetran(): boolean {
    return (this.user.type == this.userType.ADMINISTRADOR_DETRAN)
  }

  isCandidate(): boolean {
    return (this.user.type == this.userType.ALUNO)
  }

  isInstructor(): boolean {
    return (this.user.type == this.userType.INSTRUTOR)
  }

  isOperator(): boolean {
    return (this.user.type == this.userType.OPERADOR_N1)
  }

  isSupervisor(): boolean {
    return (this.user.type == this.userType.SUPERVISOR)
  }

  isLogged() {
    return this.tokenService.hasToken() && this.tokenService.isTokenExpired();
  }

  getUser() {
    return this.userSubject.asObservable();
  }

  recoverFromStorage() {
    return this.tokenService.getToken();
  }

  setFromStorage() {
    this.setUser(this.tokenService.getToken());
  }

  getIp() {
    return this.localStorage.retrieve(Variables.IP_USER);
  }

  logout(type: LogoutType = LogoutType.Default) {
    switch (type) {
      case LogoutType.Inactivity:
        //this.toastrService.info('Você foi desconectado por inatividade! Por favor, faça o login novamente', 'Desconectado');
        break;
      case LogoutType.Unauthorized:
        //this.toastrService.info('Por motivos de autorização você foi desconectado do sistema. Por favor, faça o login novamente.', 'Desconectado');
        break;
      case LogoutType.Expires:
        //this.toastrService.info('Sua sessão expirou por inatividade. Por favor, faça o login novamente', 'Sua sessão expirou!');
        break;
      default:
        //this.toastrService.info('O logout foi efetuado com sucesso.', 'Logout!');
        break;
    }
    
    GuideStorageService.preserveDuring(() => {
      this.localStorage.clear();
      this.sessionStorage.clear();
      this.tokenService.removeToken();
      localStorage.removeItem("res");
    });
    const path = "/login";
    this.router.navigate([path]);
  }

  getRoles(){
    return TokenToStorageAuthModel(this.localStorage.retrieve(Variables.USER_AUTH).access_token);
  }
}

export interface StorageAuthModel {
  given_name: string,
  email: string,
  roles: string[]
}

export function TokenToStorageAuthModel(access_token: string): StorageAuthModel {
  const jwtHelperService = new JwtHelperService();
  const token = jwtHelperService.decodeToken(access_token) as {
    email: string;
    given_name: string;
    resource_access: { rinspection: { roles: string[] } };
  };
  return {
    email: token.email,
    given_name: token.given_name,
    roles: token.resource_access.rinspection.roles
  }
}
